import r from "./withMetadataArgument.js";
import e from "../../es6/parsePhoneNumber.js";
function o() {
  return r(e, arguments);
}
export { o as parsePhoneNumber };